//
//
//
//
//
//


export default {
  model: {
    prop: 'selectedItem',
    event: 'change'
  },
  props : {
    'selectedValue': {
      default: '',
    },
    'selectedItem': {
      default: false,
    },
    'items' : {
      default : '',
    },
    'additionalClasses' : {
      default : '',
    },
    'nameKey' : {
      default : 'NAME',
    },
    'valueKey' : {
      default : 'ID',
    },
  },
  mounted: function () {
    let self = this;
    let $select = $(self.$refs.select);
    if(!this.items){
      this.items = [{
        [self.valueKey] : '-',
        [self.nameKey] : 'Загрузка ...',
      }];
    }

    $select.find('option').prop('selected', false);
    if(self.selectedItem) {
      // $select.find('option[value=' + this.selectedItem + ']').prop('selected', true);
      self.$select.val(self.selectedItem);
    }
    $select.selectric({
      disableOnMobile: false,
      nativeOnMobile: false,
      //arrowButtonMarkup: '<i class="icon-arrow"></i>',
    });
    this.$select = $select;
    this.$selectric = $select.data('selectric');
    this.$select.on('selectric-change', function() {
      self.selectedItem = self.$select.val();
      self.selectChanged();
    });
    self.selectedItem = self.$select.val();
    self.selectChanged();
  },
  methods: {
    selectChanged() {
      let self = this;
      self.$emit('change', self.$refs.select.value);
      self.$selectric.refresh();
    },
  },
  updated : function() {
    let self = this;

    self.$select.val(self.selectedItem);
    self.$selectric.refresh();
  },
  watch : {
    selectedItem: function (newValue, oldValue) {
      let self = this;
      self.$select.val(self.selectedItem);
      self.$selectric.refresh();
    },
    selectedValue: function (newValue, oldValue) {
      let self = this;
      self.selectedItem = newValue;
      self.$select.val(newValue);
      self.$select.selectric('refresh');
      // this.$emit('change', newValue);
      // this.$forceUpdate(); // It isn't present in DOM directly, so we must induce update manually!
    },
    items: function (newValue, oldValue) {
      let self = this;
      if(self.items && self.items[Object.keys(self.items)[0]] && (!self.selectedItem || self.selectedItem == '-') ){
        self.selectedItem = self.items[Object.keys(self.items)[0]][self.valueKey];
      }
      self.$forceUpdate(); // It isn't present in DOM directly, so we must induce update manually!
    }
  }
};



// WEBPACK FOOTER //
// ./www/local/vue.js/v-selectric/v-selectric.vue